import { castStoneServiceStores } from "@intrasync/cast-stone";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Service stores from `@intrasync/cast-stone`. ServiceStore registration is
 * first-wins/idempotent (see StoreRegistry.registerServiceStore), so any name
 * another module already registers with richer config is filtered out here to
 * avoid shadowing it.
 *
 * Collision check (2026-08-14): none of the package's `cast-stone-*` names
 * appear anywhere else in src/serviceStores/, so the set is empty.
 */
const STORES_OWNED_BY_OTHER_MODULES = new Set<string>([]);

export const castStoneStores: ServiceStoreConfig[] = (
  castStoneServiceStores as unknown as ServiceStoreConfig[]
).filter((store) => !STORES_OWNED_BY_OTHER_MODULES.has(store.name));
